import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { TableModel } from 'src/app/models/table.model';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';
import { AssignToEditorModel } from '../models/assign.to.editor.model';
import { PagedPendingGroupedModel } from '../models/paged.pending.grouped.model';
import { PagedRawImageDetailModel } from '../models/paged.raw.image.detail.model';
import { RemoveAssigneeModel } from '../models/remove.assignee.model';

@Injectable()
export class RawImageService {

    constructor(private http: HttpClient) { }

    pendingGroupedList(tableModel: TableModel): Observable<PagedPendingGroupedModel> {
        let url = `${environment.apiUrl}/api/chief-editor/rawImage/pending-grouped-list`;
        const tempArr = [];
        if (tableModel) {
            tempArr.push(tableModel.toQueryString());
        }
        if (tempArr.length) {
            url += '?' + tempArr.join('&');
        }
        return this.http.get<PagedPendingGroupedModel>(url);
    }

    assignToEditer(model: AssignToEditorModel) {
        return this.http.post(`${environment.apiUrl}/api/chief-editor/rawImage/assign-to-editor`, model);
    }

    removeAssignee(model: RemoveAssigneeModel) {
        return this.http.post(`${environment.apiUrl}/api/chief-editor/rawImage/remove-assigned-editor`, model);
    }

    sendForApproval(unixTimeStamp: number) {
        return this.http.post(`${environment.apiUrl}/api/chief-editor/rawImage/send-for-approval`, unixTimeStamp);
    }

    sendSelectedImagesForApproval(rawImageIds: Array<string>) {
        return this.http.post(`${environment.apiUrl}/api/chief-editor/rawImage/send-selected-images-for-approval`, rawImageIds);
    }

    getList(unixTimeStamp: number, contributorId: string, tableModel: TableModel): Observable<PagedRawImageDetailModel> {
        let url = `${environment.apiUrl}/api/chief-editor/rawImage/list`;
        const queryParams = [];
        if (!isNullOrUndefined(unixTimeStamp)) {
            queryParams.push(`unixTimeStamp=${unixTimeStamp}`);
        }
        if (!isNullOrUndefined(contributorId)) {
            queryParams.push(`contributorId=${contributorId}`);
        }
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<PagedRawImageDetailModel>(url);
    }

    markAsUnprocessed(rawImageIds: Array<string>) {
        return this.http.post(`${environment.apiUrl}/api/chief-editor/rawImage/mark-as-unprocessed`, rawImageIds);
      }
}
